// PagoExitoso.jsx — destino tras completar el pago en Stripe
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { trackStartTrial } from "../analytics/googleAnalytics";
import "./Premium.css";

export default function PagoExitoso() {
  // Marca la conversión de PRUEBA en GA4 al volver de Stripe (el cobro real de
  // el cobro real lo emite el backend a los 7 días vía Measurement Protocol,
  // con el importe que devuelve Stripe, no con una cifra fija). Usa el
  // session_id como transaction_id y sessionStorage para no contar doble en recargas.
  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) return;

    const dedupeKey = `wayo_trial_tracked_${sessionId}`;
    if (window.sessionStorage.getItem(dedupeKey)) return;
    window.sessionStorage.setItem(dedupeKey, "1");

    trackStartTrial({ transactionId: sessionId });
  }, []);

  return (
    <>
      <Helmet>
        <title>Pago completado · Wayo</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <Header />

      <main className="premium-web">
        <section className="premium-web-hero">
          <div className="premium-web-card pago-ok-card">
            <div className="pago-ok-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="34" height="34" fill="none"
                   stroke="currentColor" strokeWidth="3"
                   strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </div>

            <h1 className="pago-ok-title">Pago completado</h1>
            <p className="pago-ok-sub">
              Tu suscripción a <strong>Wayo Premium</strong> ya está activa.
            </p>

            <div className="pago-ok-next">
              <div className="pago-ok-row">
                <span className="pago-ok-tag">Primera vez en Wayo</span>
                <p>
                  Te hemos enviado un email para <strong>crear tu contraseña</strong>.
                  Revisa tu bandeja de entrada (y la carpeta de spam) y abre el enlace.
                </p>
              </div>
              <div className="pago-ok-row">
                <span className="pago-ok-tag">¿Ya tenías cuenta?</span>
                <p>
                  Entra en la app con tu <strong>email y contraseña de siempre</strong>:
                  el Premium ya está activado, no necesitas hacer nada más.
                </p>
              </div>
            </div>

            <a className="premium-web-cta pago-ok-cta" href="https://wayoai.app/download">
              Abrir la app
            </a>

            <p className="pago-ok-help">
              ¿Necesitas ayuda? Escríbenos a{" "}
              <a href="mailto:soporte@wayoai.app">soporte@wayoai.app</a>
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
